export default "__VITE_ASSET__y78GR$RJ__"